import { z } from 'zod';

const ENV_SCHEMA = z.object({
	// Api URLS
	REACT_APP_API_URL_PROJECT: z.string(),
	REACT_APP_API_URL_STATS: z.string(),
	REACT_APP_API_URL_REPORT: z.string(),
	REACT_APP_API_URL_USER: z.string(),
	REACT_APP_API_URL_USER_ACCOUNT: z.string(),
	REACT_APP_API_URL_NOTIFICATIONS: z.string(),
	REACT_APP_API_URL_DATAENTRY: z.string(),
	REACT_APP_API_URL_XLSXCSV: z.string(),
	REACT_APP_API_URL_TEMPLATES: z.string(),
	REACT_APP_API_URL_UPLOAD_FILE: z.string(),

	REACT_APP_COGNITO_USER_POOL_ID: z.string(),
	REACT_APP_COGNITO_USER_POOL_CLIENT_ID: z.string(),
	REACT_APP_COGNITO_IDENTITY_POOL_ID: z.string(),
	REACT_APP_ENVIRONMENT: z.enum([
		'development',
		'systest',
		'production',
		'playground',
		'playground_2',
		'test',
		'local_to_playground_2',
		'local_to_systest'
	])
});

const parseResult = ENV_SCHEMA.safeParse(process.env);

if (!parseResult.success) {
	document.body.innerHTML = `
		<div style="background-color: #E94747; color: white; padding: 10px;">
			<h1>Missing environment variable configuration. Provide the variables and refresh the page manually.</h1>
			<pre>${JSON.stringify(parseResult.error, null, 2)}</pre>
		</div>
	`;
	console.error(parseResult.error);
	throw new Error(parseResult.error.message);
}

const env: z.infer<typeof ENV_SCHEMA> = parseResult.data;

export { env };
